var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBadgeScan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    stroke: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M15 13.723c0-.402-.084-.726-.25-.998-.349-.53-.864-.867-1.42-1.062-.557-.194-.92-.285-1.365-.401a3.065 3.065 0 01-.64-.247c-.39-.194-.682-.479-.682-.945 0-.557.473-1.05 1.294-1.05.724 0 1.212.35 1.504 1.128l1.155-.415c-.264-.842-.863-1.593-1.935-1.813V7h-1.308v.894C10.128 8.1 9.32 8.917 9.32 10.122c0 .79.418 1.308.919 1.658.487.35 1.058.518 1.378.609.501.142 1.016.259 1.406.466.39.207.655.505.655 1.036a.994.994 0 01-.32.726c-.237.22-.613.375-1.128.375-.78 0-1.253-.324-1.532-.686-.292-.363-.403-.777-.459-.972L9 13.671c.111.505.348 1.023.752 1.464.39.44.946.803 1.67.958V17h1.309v-.868c1.503-.194 2.269-1.114 2.269-2.41z",
    clipRule: "evenodd"
  }));
}
export default SvgIconBadgeScan;